import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';




import { Horse_show } from '../models/horse_show';
import { Horse_show_entry } from '../models/horse_show_entry';
import { Checkout_request_summary } from '../models/accounting/checkout_request_summary';
import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class CheckoutRequestService {

  constructor(private http: HttpClient) { }

	getCheckoutRequest(horse_show_id: string, entry_id_list: string[]): Promise<Checkout_request_summary> {

            let put_data = {data: {type: 'checkout_request',  attributes: {
            		checkout_request: {horse_show_id: horse_show_id, entry_id_list: entry_id_list}
            	}
              }
        	};

        	return new Promise((resolve, reject) => {
	            return this.http.put(AppSettings.API_ENDPOINT + 'accounting/checkout_request',
	                put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
	                     if(response.data && response.type=='checkout_request_summary') {
	                       resolve(response.data);
	                       }  else {
	                         reject(response);
	                       }

	                }, error => {
                    if(error instanceof HttpErrorResponse){
                      reject(error.error);
                    } else {
                      reject(error);
                    }
	                });
            });



	}

}
